/**
 * Centralised blog configuration constants.
 * All blog-specific magic values live here — never hardcode them inline.
 */

/** "All categories" sentinel value used in filter state */
export const BLOG_CATEGORY_ALL = "All";

/** Minimum search query length before filtering kicks in */
export const BLOG_SEARCH_MIN_LENGTH = 1;

/** Open Graph image fallback when an article has no featuredImage */
export const BLOG_OG_IMAGE_FALLBACK = "/logo-full.webp";

/** Base URL used in canonical and JSON-LD (imported from site constants) */
export { SITE_URL } from "../config/constants";
